import { OEText } from '@openeducation/oe-it-components';
import { styled } from '@openeducation/oe-it-themes';
import React from 'react';

import { useMessageCompose } from '../../hooks/use-message-compose';
import { useMessages } from '../../hooks/use-messages';
import { PortalPaths } from '../../interfaces/portal-paths.enum';
import { MessageCard } from '../../organisms/message-card/message-card';
import { PortalLayout } from '../../templates/portal-layout/portal-layout';

export interface MessagesPageProps {}

export const MessagesPage = () => {
  const { data, isLoading, remove, onPagination, pagination } = useMessages();
  const { canComposeMessages } = useMessageCompose();

  return (
    <PortalLayout selectedPage={PortalPaths.Messages} title="Messages">
      <Container>
        <Header>
          <OEText fontSize={32} lineHeight={32} fontType="bold">
            Messages
          </OEText>
        </Header>
        <MessageCard
          isLoading={isLoading}
          data={data}
          onRemove={remove}
          canCompose={canComposeMessages}
          onPagination={onPagination}
          pagination={pagination}
        />
      </Container>
    </PortalLayout>
  );
};

const Container = styled.View`
  gap: 32px;
  padding-bottom: 32px;
`;

const Header = styled.View`
  flex-direction: row;
  justify-content: space-between;
`;
